module.exports = __webpack_public_path__ + "zilla-slab-latin-300.b75dbb2647c9bfcf151d1859ae71a1a9.woff";